export const numberFormatter = (num: number) => {
    return Math.round(num)
}